<template>
  <div :class="`ckbox ckbox-${color}`">
    <input
      :id="id"
      ref="input"
      type="checkbox"
      :checked="shouldBeChecked"
      :disabled="disabled"
      :name="name"
      :readonly="readonly"
      @change="updateInput"
    />
    <label :for="id" class="labelCheckbox">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "woodys-checkbox",
  props: {
    name: String,
    disabled: Boolean,
    readonly: Boolean,
    value: [Boolean, Number, Object],
    propertyKey: String,
    modelValue: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    color: {
      type: String,
      default: "primary",
      validator: function(value) {
        return (
          ["primary", "default", "danger", "info", "success"].indexOf(value) !==
          -1
        );
      }
    }
  },
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = Math.random()
      .toString(16)
      .slice(2);
  },
  computed: {
    shouldBeChecked() {
      if (this.modelValue instanceof Array) {
        if (this.propertyKey) {
          return (
            this.modelValue.find(
              value => value[this.propertyKey] === this.value[this.propertyKey]
            ) !== undefined
          );
        } else {
          return this.modelValue.includes(this.value);
        }
      }

      return this.modelValue === this.trueValue;
    }
  },
  methods: {
    updateInput() {
      let isChecked = event.target.checked;

      if (this.modelValue instanceof Array) {
        let newValue = this.modelValue;

        if (isChecked) {
          newValue.push(this.value);
        } else {
          let removeIndex = -1;

          if (this.propertyKey) {
            for (const key in this.modelValue) {
              if (this.modelValue.hasOwnProperty(key)) {
                const element = this.modelValue[key];

                if (
                  element[this.propertyKey] === this.value[this.propertyKey]
                ) {
                  removeIndex = key;
                  break;
                }
              }
            }
          } else {
            removeIndex = newValue.indexOf(this.value);
          }

          if (removeIndex != -1) {
            newValue.splice(removeIndex, 1);
          }
        }

        this.$emit("change", newValue);
      } else {
        this.$emit("change", isChecked ? this.trueValue : this.falseValue);
      }
    }
  }
};
</script>

<style>
.labelCheckbox {
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/WoodysCheckbox.vue